export const PLACED_SIGNATURES = Symbol() as InjectionKey<Ref<PlacementMap>>

export const PAGE_NUMBER = Symbol() as InjectionKey<number>

export const ZOOM = Symbol('skr:zoom') as InjectionKey<{
  zoomToItem: (element: HTMLElement, targetRatio?: number) => void
}>
export const ZOOM_FACTOR = Symbol('skr:zoom:factor') as InjectionKey<Ref<number>>
export const ZOOM_MAX = Symbol('skr:zoom:max') as InjectionKey<number>

export const SCENE_WIDTH = Symbol() as InjectionKey<Ref<number>>
export const SCENE_HEIGHT = Symbol() as InjectionKey<Ref<number>>

export const DOCUMENT_ID = Symbol() as InjectionKey<string>
